(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('AppraisalScrub', AppraisalScrub);

    AppraisalScrub.$inject = ['$resource'];

    function AppraisalScrub ($resource) {
        var resourceUrl = 'api/scrub-results/:id';

        return $resource(resourceUrl, {}, {
            'get': { method: 'GET' },
            'getByOrder': {
                method: 'GET',
                url: 'api/appraisal-orders/:orderId/scrub-results',
                isArray: true
            },
            'reScrub': {
                method: 'POST',
                url: 'api/appraisal-orders/:orderId/re-scrub'
            }
        });
    }
})();
